import { useState, useEffect } from "react";
import { useApi } from "../Api";

interface UserProfile {
  displayName?: string;
  bio?: string;
  billComCustomerId?: string;
  hasBillComCustomerId: boolean;
}

export const useBillComCheck = (): boolean | null => {
  const api = useApi();
  const [hasBillComAccess, setHasBillComAccess] = useState<boolean | null>(null);

  useEffect(() => {
    const checkBillComAccess = async () => {
      try {
        const response = await api.get("/api/profile/getprofile");
        const profile: UserProfile = response.data;
        setHasBillComAccess(profile.hasBillComCustomerId);
      } catch (err) {
        console.error("Failed to check Bill.com access", err);
        setHasBillComAccess(false);
      }
    };

    checkBillComAccess();
  }, [api]);

  return hasBillComAccess;
};
